import React, { useState } from "react";
import { navLinks } from "../data/data";
import { hero } from "../data/data";
import "./Nav.css";
import { GiHamburgerMenu } from "react-icons/gi";

const Nav = () => {
  const [open, setOpen] = useState(false);

  const handleNavClick = () => setOpen(false);

  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-logo">{hero.logoText}</div>
        <ul className="nav-list desktop">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a href={`#${link.id}`}>{link.label}</a>
            </li>
          ))}
        </ul>
        <button
          className="nav-hamburger"
          onClick={() => setOpen((v) => !v)}
          aria-label="Otwórz menu">
          {/* <span className="hamburger-icon" /> */}
          <GiHamburgerMenu className="hamburger-icon" />
        </button>
        {open && (
          <div className="nav-mobile-overlay" onClick={handleNavClick}>
            <ul
              className="nav-list mobile"
              onClick={(e) => e.stopPropagation()}>
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={`#${link.id}`} onClick={handleNavClick}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Nav;
